import React, { useState } from "react";
import "./packages.css";

import groupImg from "../../../Assets/Images/home/p-1.png";
import indivImg from "../../../Assets/Images/home/p-2.png";
import teamImg from "../../../Assets/Images/home/p-3.png";
import unlimitedImg from "../../../Assets/Images/home/p-3.png";
import { useInstructions } from "../../../APIContext/InstructionsContext";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import EnquiryModal from "../../EnquiryModal/EnquiryModal";

const Packages = ({ data, setShowModal }) => {
  const { packages, fetchGroupInstructions } = useInstructions();
  const navigate = useNavigate();
  // const [showModal, setShowModal] = useState(false);

  // console.log(fetchGroupInstructions)
  useEffect(() => {
    fetchGroupInstructions();
  }, []);

  const descriptions = {
    "GROUP INSTRUCTION":
      "When you purchase a package of Group Instruction Sessions you will be grouped by age. The session will be lead by one of Shootin' School's Head Instructors. These sessions are built to give players a workout at the appropriate age and skill level while also adding some competitive drills to the session.",
    "INDIVIDUAL INSTRUCTION":
      "When you purchase a package of Individual Instruction Sessions you are guaranteed to receive 1 on 1 instruction. This means that 1 trainer will be assigned to only 1 player.",
    "TEAM INSTRUCTION":
      "Test when you purchase a package of Group Instruction Sessions you are subject to be in a group with 3 other players that are on your skill level or in your age group. The maximum amount of people in a group is 4 players and 1 instructor.",
    "UNLIMITED INSTRUCTION":
      "You can purchase Unlimited Group Instruction. You have access to our instruction every day that we train for 1 hour. The Unlimited Plan is a 4 month agreement. This means that you must participate in the plan for 4 consecutive months.",
  };

  const getNavigationFn = (id, pid) => {
    if (id === 0) {
      window.location.href = `/group-instruction?id=${pid}`;
    } else if (id === 1) {
      window.location.href = `/individual-instruction?id=${pid}`;
    } else if (id === 2) {
      window.location.href = `/unlimited-instruction?id=${pid}`;
    } else if (id === 3) {
      window.location.href = `/team-workout?id=${pid}`;
    }
  };

  return (
    <div style={{ "--br-value": 1.28 }} className="bg-custom brightness">
      <section className="program-packages-section">
        <div className="container">
          <h2 className="packages-title">OUR MOST POPULAR PACKAGES</h2>

          <div className="packages-grid">
            {data?.map((item) => (
              <div key={item.id} className="package-card">
                <div style={{ minHeight: "205px" }}>
                  <h3 className="text-clip">{item.name}</h3>
                  <p className="text-clip">{item.description}</p>
                </div>
                <button className="vb-btn" onClick={() => setShowModal(true)}>
                  <span className="text-clip">Inquiry now</span>
                </button>
                {/* <div className="package-img">
                <img src={item.image} alt="Group Instruction" />
              </div> */}
              </div>
            ))}
          </div>
        </div>
        {/* {showModal && <EnquiryModal onClose={() => setShowModal(false)} />} */}
      </section>
    </div>
  );
};

export default Packages;
